import angular from "angular";
import { angularServicesNames } from "@topline/services/angularServicesNames";

class ConfigurationConfig {
    static $inject = ["$stateProvider"];

    constructor(private $stateProvider: ng.ui.IStateProvider) {
        this.init();
    }

    private init() {
        this.$stateProvider.state("configuration", {
            url: "^/configuration",
            template: require("./views/configuration.html"),
            controller: "ConfigurationCtrl",
            controllerAs: "$ctrl",
            resolve: {
                translateReady: [
                    angularServicesNames.$translate,
                    ($translate: ng.translate.ITranslateService) => {
                        return $translate.onReady();
                    }
                ]
            }
        });
    }
}

angular.module("topline.modules").config(ConfigurationConfig);
